// Cancellation and unchecked attendance are not absence decisions.
function portalAttendanceOutcome(item = {}) {
  if (item.lessonStatus === 'cancelled' || item.attendanceStatus === 'cancelled' ||
      ['cancelledOnTime', 'cancelledLate'].includes(item.participationStatus)) return 'cancelled';
  const checked = item.attendanceStatus === 'checked' ||
    (!item.attendanceStatus && typeof item.isPresent === 'boolean');
  if (!checked || typeof item.isPresent !== 'boolean') return 'notChecked';
  return item.isPresent ? 'present' : 'absent';
}

module.exports = { portalAttendanceOutcome };
